module.exports = __webpack_public_path__ + "img/icon-setting-enable.481a1452.svg";